'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _themeCart = require('@shopify/theme-cart');

var shopifyCart = _interopRequireWildcard(_themeCart);

var _components = require('../vue/components');

var _components2 = _interopRequireDefault(_components);

var _types = require('../vue/components/PushCart/types');

var pushCartTypes = _interopRequireWildcard(_types);

var _store = require('../vue/store');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** @param {{ properties: Record<string, string> }[]} items */
function getCartGroups(items) {
  var groups = {};
  items.forEach(function (item) {
    var uid = item.properties['__Parent uid'] || item.properties['__Child uid'];

    if (!uid) {
      return;
    }

    if (!groups[uid]) {
      groups[uid] = [];
    }

    groups[uid].push(item);
  });

  return groups;
}

var PushCart = function PushCart(el) {
  (0, _classCallCheck3.default)(this, PushCart);

  var action = el.dataset.action;
  var maxQuantity = parseInt(el.dataset.maxQuantity, 10);
  var submitTo = el.dataset.submitTo;
  var translations = {
    action: el.dataset.translationAction,
    checkout: el.dataset.translationCheckout,
    remove: el.dataset.translationRemove,
    subtotal: el.dataset.translationSubtotal,
    title: el.dataset.translationTitle,
    shipping: el.dataset.translationShipping,
    note: el.dataset.translationNote,
    continue: el.dataset.translationContinue,
    terms: JSON.parse(el.dataset.translationTerms),
    gifts: {
      selectYourItems: {
        plural: el.dataset.translationSelectYourItemsPlural,
        singular: el.dataset.translationSelectYourItemsSingular
      },
      totalItemsAdded: el.dataset.translationTotalItemsAdded,
      selectXItems: {
        plural: el.dataset.translationSelectXItemsPlural,
        singular: el.dataset.translationSelectXItemsSingular
      },
      addToCart: el.dataset.translationAddToCart,
      previousSlide: el.dataset.translationPreviousSlide,
      nextSlide: el.dataset.translationNextSlide,
      complimentaryItem: el.dataset.translationComplimentaryItem
    },
    promoted: {
      wasPrice: el.dataset.translationPromotedWasPrice,
      nowPrice: el.dataset.translationPromotedNowPrice
    }
  };
  var delivery = {
    firstTier: {
      minimum: parseInt(el.dataset.deliveryFirstTierMinimum, 10),
      maximum: parseInt(el.dataset.deliveryFirstTierMaximum, 10),
      message: el.dataset.deliveryFirstTierMessage
    },
    secondTier: {
      minimum: parseInt(el.dataset.deliverySecondTierMinimum, 10),
      maximum: parseInt(el.dataset.deliverySecondTierMaximum, 10),
      message: el.dataset.deliverySecondTierMessage
    }
  };
  var discount = {
    enabled: el.dataset.discountEnabled === 'true',
    string: el.dataset.discountString,
    buttonLabel: el.dataset.discountButtonLabel,
    appliedMessage: el.dataset.discountAppliedMessage
  };
  var grapheneHC = {
    enabled: el.dataset.graphenePushCart === 'true'
  };
  var promoted = {
    enabled: el.dataset.promotedProductEnabled === 'true',
    productId: parseInt(el.dataset.promotedProductId),
    productImage: el.dataset.promotedProductImage,
    title: el.dataset.promotedTitle,
    text: el.dataset.promotedText,
    price: el.dataset.promotedPrice,
    variantPrice: el.dataset.promotedVariantPrice,
    variantCompareAtPrice: el.dataset.promotedVariantCompareAtPrice,
    buttonText: el.dataset.promotedButtonText
  };
  var gifts = {
    products: JSON.parse(el.dataset.giftProducts),
    threshold: Number(el.dataset.giftThreshold),
    maxGifts: Number(el.dataset.giftMaxGifts),
    discountRate: Number(el.dataset.giftDiscountRate),
    initiallyOpen: JSON.parse(el.dataset.giftInitiallyOpen)
  };
  var store = (0, _store.createStore)({
    initialData: {
      pushCart: {
        action: action,
        maxQuantity: maxQuantity,
        submitTo: submitTo,
        translations: translations,
        delivery: delivery,
        discount: discount,
        grapheneHC: grapheneHC,
        promoted: promoted,
        gifts: gifts
      }
    }
  });

  shopifyCart.getState().then(function (data) {
    var groups = getCartGroups(data.items);

    var groupArray = (0, _keys2.default)(groups).map(function (key) {
      return groups[key];
    });

    var groupsOfSingleItems = groupArray.filter(function (group) {
      return group.length === 1;
    });

    var itemsToRemove = groupsOfSingleItems.map(function (_ref) {
      var _ref2 = (0, _slicedToArray3.default)(_ref, 1),
          item = _ref2[0];

      return item;
    }).filter(function (item) {
      var isPersonalised = item.properties.__Personalised === 'true';
      var isPersonalisationFee = item.properties._type === 'Personalisation';

      return isPersonalised || isPersonalisationFee;
    });

    if (itemsToRemove.length === 0) {
      return data;
    }

    var itemsWithZeroQuantity = itemsToRemove.map(function (item) {
      item.quantity = 0;
      return item;
    });

    return store.dispatch(pushCartTypes.ACTION__UPDATE_QUANTITY_OF_MULTIPLE_ITEMS, {
      data: itemsWithZeroQuantity
    }).then(function () {
      if (window.location.pathname === '/cart') {
        window.location.reload();
      }

      return shopifyCart.getState();
    });
  }).then(function (data) {
    return store.commit(pushCartTypes.MUTATION__UPDATE_LINE_ITEMS, data);
  }).catch(function (err) {
    return console.error('Push cart error: ' + err);
  });

  new _vue2.default({
    store: store,
    components: _components2.default,
    template: '<PushCart />'
  }).$mount(el);
};

exports.default = PushCart;